import React, { useState, useEffect } from "react";
import "./Template_2.css";

const Template_2_HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image:
        "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Explore The World's Beauty",
      description:
        "Discover hidden gems and breathtaking landscapes with our curated travel experiences",
    },
    {
      image:
        "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
      title: "Adventure Awaits You",
      description:
        "From mountain peaks to ocean depths, find your next great adventure",
    },
    {
      image:
        "https://images.unsplash.com/photo-1505832018823-50331d70d237?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1508&q=80",
      title: "Create Lasting Memories",
      description:
        "Journey with us and create stories you'll tell for a lifetime",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slides.length) % slides.length
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="Template_2 hero-slider">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`Template_2 slide ${
            index === currentSlide ? "Template_2 active" : ""
          }`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="Template_2 slide-overlay"></div>
          <div className="Template_2 slide-content">
            <h1>{slide.title}</h1>
            <p>{slide.description}</p>
            <div className="Template_2 button-group">
              <button className="Template_2 hero-cta primary">
                Explore Now
              </button>
              <button className="Template_2 hero-cta secondary">
                Learn More
              </button>
            </div>
          </div>
        </div>
      ))}

      <div className="Template_2 slider-controls">
        <div className="Template_2 slider-arrows">
          <div className="Template_2 arrow Template_2 prev" onClick={prevSlide}>
            <i className="fas fa-chevron-left"></i>
          </div>
          <div className="Template_2 arrow Template_2 next" onClick={nextSlide}>
            <i className="fas fa-chevron-right"></i>
          </div>
        </div>

        <div className="Template_2 slider-nav">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`Template_2 slider-dot ${
                index === currentSlide ? "Template_2 active" : ""
              }`}
              onClick={() => goToSlide(index)}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Template_2_HeroSection;
